"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BreadcrumbUpdate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BreadcrumbUpdate, _PureComponent);

  function BreadcrumbUpdate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BreadcrumbUpdate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BreadcrumbUpdate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "updateContext", function () {
      var _this$props = _this.props,
          update = _this$props.update,
          title = _this$props.title,
          value = _this$props.value,
          visible = _this$props.visible,
          loading = _this$props.loading,
          context = _this$props.breadcrumbContext,
          excludes = _this$props.excludes;
      var updatePathMap = context.updatePathMap,
          location = context.location;

      if (updatePathMap) {
        if (update) {
          if ((0, _lib.isObj)(update)) {
            updatePathMap(excludes, update);
          } else {
            updatePathMap(excludes, update(context));
          }

          return;
        }

        if (title || value || visible || loading) {
          var newPathObjProps = {
            title: title,
            value: value,
            visible: visible,
            loading: loading
          };
          var data = context.data;
          var pathObjProps = data[data.length - 1];

          if (pathObjProps) {
            var keys = Object.keys(pathObjProps);
            keys.forEach(function (k) {
              var newValue = newPathObjProps[k];

              if (newValue || (0, _lib.isBool)(newValue)) {
                pathObjProps[k] = newValue;
              }
            });
          }

          updatePathMap(excludes, _defineProperty({}, location.pathname, pathObjProps));
        }
      }
    });

    return _this;
  }

  _createClass(BreadcrumbUpdate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateContext();
      var _this$props2 = this.props,
          onMount = _this$props2.onMount,
          breadcrumbContext = _this$props2.breadcrumbContext;

      if (onMount) {
        onMount(breadcrumbContext);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          breadcrumbContext = _this$props3.breadcrumbContext,
          update = _this$props3.update,
          value = _this$props3.value,
          visible = _this$props3.visible,
          loading = _this$props3.loading;

      if (prevProps.update !== update || prevProps.value !== value || prevProps.visible !== visible || prevProps.loading !== loading) {
        this.updateContext();
      }

      if (prevProps.breadcrumbContext.data !== breadcrumbContext.data) {
        var onChange = this.props.onChange;

        if (onChange) {
          onChange(breadcrumbContext);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var breadcrumbContext = this.props.breadcrumbContext;
      var updatePathState = breadcrumbContext.updatePathState;

      if (updatePathState) {
        updatePathState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          breadcrumbContext = _this$props4.breadcrumbContext;
      return (0, _lib.getRenderProps)(children, breadcrumbContext);
    }
  }]);

  return BreadcrumbUpdate;
}(_react.PureComponent);

exports.default = BreadcrumbUpdate;

_defineProperty(BreadcrumbUpdate, "propTypes", {
  children: _propTypes.default.node,
  onMount: _propTypes.default.func,
  onChange: _propTypes.default.func,
  breadcrumbContext: _propTypes.default.shape({
    location: _propTypes.default.object
  }).isRequired,
  update: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.shape({
    value: _propTypes.default.string,
    visible: _propTypes.default.bool,
    loading: _propTypes.default.bool
  })))]),
  excludes: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  title: _propTypes.default.string,
  value: _propTypes.default.string,
  visible: _propTypes.default.bool,
  loading: _propTypes.default.bool
});

_defineProperty(BreadcrumbUpdate, "defaultProps", {
  children: null,
  onMount: null,
  onChange: null,
  update: null,
  excludes: null,
  title: null,
  value: null,
  visible: true,
  loading: false
});